import { useState, useRef, useEffect } from 'react'
import CloseIcon from '../../../assets/icons/close.svg?react';
import SearchBox from '../../../components/SearchBox/SearchBox';
import ResetIcon from '../../../assets/icons/reset.svg?react';
import Pagination from '../../../components/Pagination/Pagination';
import useAlgoSimple from '../../../hooks/useAlgoSimple';
import { SkeletonTable } from '../../../components/Skeleton';
const AlgoSelectModal = ({ onClose, onPutAlgoToDrResource, currentAlgo, currentAlgoVersion }) => {
  const [selectedAlgo, setSelectedAlgo] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [canSearch, setCanSearch] = useState(true);
  const searchBoxRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { algoList, algoListLoading, algoListError, refetchAlgoList, totalCount } = useAlgoSimple(
    {
      page: currentPage,
      pageSize: pageSize,
      ModuleName: searchValue,
    }
  );
  useEffect(() => {
    if (currentAlgo && currentAlgoVersion) {
      setSelectedAlgo(algoList?.Items?.find(item => item.ModuleName === currentAlgo && item.Version === currentAlgoVersion));
    }
  }, [currentAlgo, currentAlgoVersion]);
  const handleSearch = (value) => {
    setSearchValue(value);
  }
  const handlePageChange = (page) => {
    setCurrentPage(page);
  }
  const handleReset = () => {
    if (searchBoxRef.current) {
      searchBoxRef.current.reset();
    }
    setSearchValue('');
    setCanSearch(true);
  }

  const handleSelect = (algo) => {
    setSelectedAlgo(algo);
  }

  const handleSubmit = () => {
    onPutAlgoToDrResource(selectedAlgo, () => {
      // PUT 요청 성공 시에만 모달 닫기
      onClose();
    });
  }
  return (
    <div className="modal-background">
      <div className="modal-container station-search-modal-container">
        <div className="modal-header p-10">
          <h3>알고리즘 검색</h3>
        </div>
        <button className="close-btn" onClick={onClose}>
          <CloseIcon />
        </button>
        <div className="modal-content p-10">
          <div className='flex gap-4 mb-10'>
            <SearchBox 
              ref={searchBoxRef}
              placeholder="알고리즘 이름을 입력하세요."
              onSearch={handleSearch}
              showFilter={false}
              onSearchStateChange={setCanSearch}
              defaultValue={searchValue}
              selectedFilterRef={null}
              searchValueRef={null}
            />
            <button className="btn btn-primary px-14" onClick={() => {handleSearch(searchValue)}}>
              검색
            </button>
            <button className="btn big-btn btn-style-2 flex align-center gap-2" onClick={handleReset}>
              <ResetIcon />
              초기화
            </button>
          </div>
          <div className='primary-table'>
            <table>
              {algoListLoading && (
                <SkeletonTable rows={8} columns={5} />
              )}
              {!algoListLoading && !algoListError && (
              <>
              <thead>
                <tr>
                  <th>번호</th>
                  <th></th>
                  <th>알고리즘 이름</th>
                  <th>버전 식별자</th>
                </tr>
              </thead>
              <tbody>
                {algoListError && (
                  <tr>
                    <td colSpan="4" className="no-data">
                      알고리즘 데이터를 불러오는데 실패했습니다.
                    </td>
                  </tr>
                )}
                {!algoListLoading && !algoListError && algoList?.Items?.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="no-data">
                      알고리즘 데이터가 없습니다.
                    </td>
                  </tr>
                ) : (
                  !algoListLoading && !algoListError && algoList?.Items?.map((module, idx) => {
                    return (
                      <tr key={module.CblModuleInfoSysId}>
                        <td width="60px">{idx + 1}</td>
                        <td width="30px"><input type="checkbox" checked={selectedAlgo?.CblModuleInfoSysId === module.CblModuleInfoSysId} onChange={() => handleSelect(module)} /></td>
                        <td>{module.ModuleName}</td>
                        <td>{module.Version}</td>
                      </tr>
                    );
                  })
                  )}
                </tbody>
              </>
              )}
            </table>
          </div>
          <div className='pagination-wrapper'>
            <Pagination
              currentPage={currentPage}
              totalPages={Math.max(1, Math.ceil(totalCount / pageSize))}
              pageSize={pageSize}
              setPageSize={setPageSize}
              onPageChange={handlePageChange}
            />
          </div>
          <div className='modal-footer end mt-10'>
            <button className="btn btn-primary big-btn" onClick={handleSubmit}>
              알고리즘 적용
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AlgoSelectModal